export const FORM_FROM_NAME = 'from';
export const FORM_TO_NAME = 'to';
export const FORM_PERIOD_TYPE = 'periodType';
export const FORM_PERIOD_TYPE_CUSTOM = 'custom';
export const FORM_PERIOD_TYPE_MONTH = 'month';
export const FORM_PERIOD_TYPE_WEEK = 'week';
